"use client";

import { useEffect, useState } from "react";

const useSourceScreen = () => {
  const [sourceScreen, setSourceScreen] = useState("");

  useEffect(() => {
    const generateScreenValue = () => {
      // Get pathname and search params from window.location
      const pathname = window.location.pathname;
      const searchParams = new URLSearchParams(window.location.search);

      // Handle home page
      if (pathname === "/") return "home";

      // Get query parameters as object
      const queryParams = Object.fromEntries(searchParams.entries());
      const queryValues = Object.values(queryParams);
      const queryCount = queryValues.length;

      // Clean pathname (remove leading slash)
      const cleanPath = pathname.slice(1);

      if (queryCount >= 2) {
        // Multiple query parameters
        const pathSegments = cleanPath.split("/");
        return `${pathSegments[0]}/${queryValues[0]}/${queryValues}`;
      }

      if (queryCount === 1) {
        // Single query parameter
        const lastSlashIndex = pathname.lastIndexOf("/");
        const basePath = pathname.slice(0, lastSlashIndex + 1);
        return basePath + queryValues[0];
      }

      // No query parameters
      return cleanPath;
    };

    const screenValue = generateScreenValue();

    // Update sessionStorage
    if (typeof window !== "undefined") {
      sessionStorage.setItem("screenSource", screenValue);
      setSourceScreen(screenValue);
    }
  }, []); // Empty dependency array since we're reading from window.location

  // Remove leading slash if present
  return sourceScreen.startsWith("/") ? sourceScreen.slice(1) : sourceScreen;
};

export default useSourceScreen;
